export default {
  "smartwitnessVideo_deviceOffline": "Dispositivo fuera de línea, no se puede procesar la solicitud",
  "smartwitnessVideo_viewCameraEvents": "Ver Eventos de Cámara",
  "smartwitnessVideo_saved": "Guardado exitosamente",
  "smartwitnessVideo_notEsn": "No ESN(serial) disponible, no se puede procesar la solicitud"
};